import { ProgramStatus } from '../../../features/entities/programs-entities';
const getGrantStatusTagTheme = (theme, status) => {
    switch (status) {
        case ProgramStatus.Completed:
        case 'open':
            return {
                tagColor: theme.colors.green_4,
                svgBackground: theme.colors.green_1,
                svgBorder: theme.colors.green_3,
            };
        case ProgramStatus.Active:
        case 'openingSoon':
            return {
                tagColor: theme.colors.purple_4,
                svgBackground: theme.colors.purple_3,
                svgBorder: theme.colors.purple_2,
            };
        case 'closed':
        case 'archived':
        case 'unknown':
            return {
                tagColor: theme.colors.grey_5,
                svgBackground: theme.colors.grey_4,
                svgBorder: theme.colors.grey_3,
            };
        case ProgramStatus.Rejected:
        case ProgramStatus.Canceled:
        case 'closingSoon':
            return {
                tagColor: theme.colors.red_5,
                svgBackground: theme.colors.error,
                svgBorder: theme.colors.red_3,
            };
        case 'suspending':
            return {
                tagColor: theme.colors.yellow_4,
                svgBackground: theme.colors.yellow_2,
                svgBorder: theme.colors.yellow_1,
            };
        case 'featured':
        default:
            return {
                tagColor: theme.colors.purple_5,
                svgBackground: 'transparent',
                svgBorder: 'transparent',
            };
    }
};
export default getGrantStatusTagTheme;
